<template>
  <div>
    <VisualHero
      image="/assets/img/visual/ucrs-visual-scopri-area-riservata.png"
      background-color="bg-black-light"
    >
      <template slot="title"> Scopri l'area riservata </template>
    </VisualHero>
    <BreadcrumbsWithShareAccordion :breadcrumbs="breadcrumbs" />
    <section class="pt-8 md:pt-20">
      <div class="container">
        <div v-if="$store.state.auth.loggedIn">
          <Accordion
            v-for="(item, index) in itemsAccordionLogged"
            :key="index"
            :heading="item.title"
            :is-open="openAccordion === index + 1"
            :content-class="item.contentClass"
            @update="(isOpen) => handleOpenUpdate(isOpen, index)"
          >
            <div v-dompurify-html="item.description"></div>
          </Accordion>
        </div>
        <div v-else>
          <Accordion
            v-for="(item, index) in itemsAccordion"
            :key="index"
            :heading="item.title"
            :is-open="openAccordion === index + 1"
            :content-class="item.contentClass"
            @update="(isOpen) => handleOpenUpdate(isOpen, index)"
          >
            <div v-dompurify-html="item.description"></div>
          </Accordion>
        </div>
      </div>
      <div class="mb-20 container">
        <StripBanner
          :link="
            $store.state.auth.loggedIn ? '/vendo' : '/area-riservata/registrati'
          "
          :btn-text="
            $store.state.auth.loggedIn ? 'Scopri di più' : 'Registrati subito'
          "
          root-class="-mx-6 md:mx-0 mt-8 mb-12"
        >
          <p v-if="$store.state.auth.loggedIn">
            Vuoi vendere casa? Gratis per te l'Attestato di Prestazione
            Energetica (APE).
          </p>
          <p v-else>
            Stai cercando casa e devi anche vendere?
            <br aria-hidden="true" />Registrati all'area riservata, scopri i
            nuovi servizi dedicati.
          </p>
        </StripBanner>
      </div>
    </section>
  </div>
</template>

<script>
// Components
import Accordion from '~/components/Accordion.vue'
import BreadcrumbsWithShareAccordion from '~/components/BreadcrumbsWithShareAccordion.vue'
import StripBanner from '~/components/StripBanner.vue'
import VisualHero from '~/components/VisualHero.vue'

export default {
  components: {
    Accordion,
    BreadcrumbsWithShareAccordion,
    StripBanner,
    VisualHero,
  },
  async asyncData({ route, $axios }) {
    let meta
    await $axios
      .get('/_api/api/v1/meta', {
        params: {
          slug: route.path,
        },
      })
      .then((res) => {
        meta = res.data.data
      })
      .catch(() => {
        meta = {
          title: 'FAQ | Area riservata UniCredit RE Services',
          description:
            'Scopri perché e come fare per registrarsi all&#039;area riservata di UniCredit RE Services. La tua dashboard dove salvare e personalizzare ricerche, immobili, gestire email e notifiche.',
        }
      })
    return { meta }
  },
  data() {
    return {
      openAccordion: 1,
      breadcrumbs: [
        {
          text: this.$store.state.auth.loggedIn ? 'La mia homepage' : 'Home',
          href: '/',
        },
        {
          text: "Scopri l'area riservata",
        },
      ],
      itemsAccordion: [
        {
          title: `Perché registrarsi all'area riservata di UniCredit RE Services?`,
          description: `
            <strong>Con la nuova area riservata di UniCredit RE Services</strong> potrai usufruire dei nuovi servizi dedicati a chi vende e a chi compra.<br aria-hidden="true">
            <strong>Se stai cercando casa potrai:</strong>
            <ul class="list-disc list-inside pl-12 mb-4">
              <li>accedere alla tua area personale in cui potrai:
                <ul class="list-inside pl-8 list-disc">
                  <li>ricevere tramite email gli ultimi aggiornamenti sulle tue preferenze</li>
                  <li>salvare le tue ricerche</li>
                  <li>i tuoi immobili preferiti</li>
                  <li>gestire in autonomia le tue notifiche</li></ul></li></ul> <strong>Se stai vendendo casa potrai:</strong> <ul class="list-disc list-inside pl-12"><li>avere GRATIS l"Attestato di Prestazione Energetica(2) e saremo al tuo fianco fino alla conclusione della compravendita.</li>
                  <li>effettuare una prima valutazione online, istantanea e gratuita della tua casa, grazie alla tecnologia Casavo (solo per immobili residenziali)</li>
                  <li>accedere alla tua area personale dove ritrovare le informazioni rilevanti sul tuo immobile in vendita:<ul class="list-disc list-inside pl-8"><li>avere sempre a disposizione i riferimenti del tuo consulente immobiliare e del tuo mandato</li>
                  <li>avere accesso al tuo report Valore Casa (se presente)</li>
                  <li>vedere un resoconto dettagliato sui contatti ricevuti</li>
                  <li>vedere le attività promozionali attivate sul tuo immobile</li>
                  <li>vedere gli appuntamenti sul tuo immobile</li>
                </ul>
              </li>
            </ul>
            <span>Cosa aspetti? Vai al form e <a href="area-riservata/registrati" target="_blank" class="text-blue underline">registrati subito</a></span>
          `,
          contentClass: 'max-h-400 md:max-h-210 lg:max-h-180',
        },
        {
          title: `La registrazione all'area riservata è gratuita?`,
          description:
            'Si, puoi registrarti gratuitamente e usufruire di tutti i servizi dedicati, <a href="/area-riservata/registrati" target="_blank" class="text-blue underline">clicca qui.</a>',
        },
        {
          title: 'Come faccio a registrarmi?',
          description: `Per effettuare la registrazione ti verranno richiesti solo i dati utili per consentirti la massima esperienza dell'area riservata: <ul class="list-disc list-inside pl-12 mt-4"><li>nome e cognome</li><li>un'indirizzo email valido</li><li>un numero di telefono utile per essere contattato</li><li>una password</li><li>dove vuoi comprare o vendere casa</li></ul>`,
        },
        {
          title: 'Come verifico se la registrazione è andata a buon fine?',
          description: `Riceverai all'indirizzo indicato in fase di registrazione, una e-mail contenente il link per completare la registrazione. Se non ti dovesse arrivare controlla nel filtro spam.`,
        },
        {
          title:
            'In fase di registrazione é obbligatorio dare il consenso alle clausole specifiche?',
          description: `Per usufruire di tutte le funzionalità dell'area riservata, al momento della registrazione ti suggeriamo di acconsentire alle condizioni richieste.`,
        },
      ],
      itemsAccordionLogged: [
        {
          title: `Cosa posso fare con l'area riservata di UniCredit RE Services?`,
          description: `
            <strong>Se stai cercando casa potrai:</strong>
            <ul class="list-disc list-inside pl-12">
              <li>accedere alla tua area personale in cui potrai:
                <ul class="list-inside pl-8 list-disc">
                  <li>ricevere tramite email gli ultimi aggiornamenti sulle tue preferenze</li>
                  <li>salvare le tue ricerche</li>
                  <li>i tuoi immobili preferiti</li>
                  <li>gestire in autonomia le tue notifiche</li>
                </ul>
              </li>
            </ul>
            <strong>Se stai vendendo casa potrai:</strong>
            <ul class="list-inside pl-8 list-disc">
              <li>avere GRATIS l"Attestato di Prestazione Energetica(2) e saremo al tuo fianco fino alla conclusione della compravendita.</li>
              <li>accedere alla tua area personale dove ritrovare le informazioni rilevanti sul tuo immobile in vendita:
                <ul class="list-inside pl-8 list-disc">
                  <li>avere sempre a disposizione i riferimenti del tuo consulente immobiliare e del tuo mandato</li>
                  <li>avere accesso al tuo report Valore Casa (se presente)</li>
                  <li>vedere un resoconto dettagliato sui contatti ricevuti</li>
                  <li>vedere le attività promozionali attivate sul tuo immobile</li>
                  <li>vedere gli appuntamenti sul tuo immobile</li>
                </ul>
              </li>
            </ul>
            <span>Cosa aspetti? Utilizza tutte le funzionalità della tua area riservata</span>
          `,
          contentClass: 'max-h-400 md:max-h-200 lg:max-h-180',
        },
      ],
    }
  },
  head() {
    return {
      title: this.meta.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta.description,
        },
      ],
    }
  },
  methods: {
    handleOpenUpdate(isOpen, index) {
      if (!isOpen) return

      this.openAccordion = index + 1
    },
  },
}
</script>
